import React from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import BookingFlow from "../components/booking/BookingFlow";
import { tourPackages, speedBoatData, luxuryYacht } from "../data/dummyData";

const BookNow = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Get selected package from location state, default to undefined
  const selectedPackage = location.state?.selectedPackage ?? 1;

  // Combine all services
  const allServices = [
    ...(tourPackages || []),
    ...(speedBoatData || []),
    ...(luxuryYacht || []),
  ];

  const service = allServices.find((item) => item.slug === slug);

  if (!service) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="bg-white rounded-2xl shadow-xl px-8 py-12 text-center max-w-md">
          <span className="text-5xl mb-4 block">😕</span>
          <h2 className="text-2xl font-bold text-red-500 mb-2">
            Service not found
          </h2>
          <p className="text-gray-600 mb-6">
            The service you're looking for doesn't exist or has been removed.
          </p>
          <button
            onClick={() => navigate("/")}
            className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all"
          >
            Back to Home
          </button>
        </div>
      </div>
    );
  }

  // Resolve package details from the service's packages array
  const pkgData = service.packages?.find((p) => p.id === selectedPackage);

  // Create enhanced service data with package info
  const enhancedService = {
    ...service,
    selectedPackage: selectedPackage,
    price: pkgData
      ? parseFloat(
          pkgData.price_per_person ||
            pkgData.price_per_group ||
            service.price ||
            0,
        )
      : parseFloat(service.price || 0),
    packagePrice: pkgData
      ? parseFloat(pkgData.price_per_person || pkgData.price_per_group || 0)
      : null,
    packageName: pkgData?.name ?? null,
    packageDuration: pkgData?.duration ?? null,
  };

  return (
    <div className="min-h-screen pt-20 sm:pt-24 px-4 pb-8 sm:pb-16 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Back Button */}
        <div className="mb-4 sm:mb-6">
          <button
            onClick={() => {
              if (service && service.slug) {
                navigate(`/${service.slug}/tour-details`);
              } else {
                navigate("/");
              }
            }}
            className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm sm:text-base group"
          >
            <FaArrowLeft className="group-hover:-translate-x-1 transition-transform" />
            <span>Back to Service Details</span>
          </button>
        </div>

        {/* Booking Flow Component */}
        <BookingFlow serviceData={enhancedService} serviceType={service.name} />
      </div>
    </div>
  );
};

export default BookNow;
